import { NavLink, useNavigate } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import { Logo, Banner } from "@zenith/shared";
import { SetShowSideBar, LandingPageImage } from "@zenith/features/LandingPage";
import { SIGN_IN } from "@zenith/routes/paths";
import ArrowDiagonalRight from "@zenith/assets/icons/ArrowDiagonalRight";
import { memo } from "react";
import { ButtonComponent } from "@zenith/components";

const LandingPage = memo(function LandingPage() {
  const { showSideBar, onSetShowSideBar, onSetButtonEffect, effect } =
    SetShowSideBar();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col overflow-x-clip">
      <header>
        <nav className="flex h-20 items-center justify-start px-7 md:justify-between">
          <div className="mr-10 block md:hidden">
            <button
              id="side-menu-button"
              data-drawer-target="default-sidebar"
              data-drawer-toggle="default-sidebar"
              aria-controls="default-sidebar"
              type="button"
              onClick={() => {
                onSetButtonEffect(true);
                onSetShowSideBar(true);
              }}
              onAnimationEnd={() => {
                onSetButtonEffect(false);
              }}
              className={`${effect && "animate-[pulse_1s_1]"} focus:outline-0`}
            >
              <MenuIcon fontSize="large" />
            </button>
          </div>

          <Logo />

          <div className="hidden items-center gap-x-8 md:flex">
            <NavLink id="header-login-link" to={SIGN_IN} className="font-bold">
              <ButtonComponent
                label="Sign In"
                size="large"
                type="tertiary"
                id="new-world-button"
                className="font-bold"
              />
            </NavLink>
            <NavLink className="w-full md:w-fit" to="sign-up">
              <ButtonComponent
                label="Open a New World"
                fullWidth
                size="large"
                type="primary"
                id="new-world-button"
                iconEnd={<ArrowDiagonalRight stroke="white" />}
              />
            </NavLink>
          </div>
        </nav>
      </header>
      <div className=" my-auto grid h-full min-w-fit grid-cols-1 lg:grid-cols-2">
        <div className="order-2 flex flex-col justify-center gap-y-7 px-3 md:px-10 lg:order-1  lg:px-20">
          <div className="flex w-full flex-col justify-center gap-y-5 md:justify-start">
            <h1 className="mt-10 text-5.5xl font-bold sm:text-7xl md:text-6xl lg:text-7xl">
              We boost
              <br />
              Your business
            </h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              euismod sem sed dolor finibus ultrices. Vestibulum dui ex, lacinia
              vitae interdum non, lobortis a quam
            </p>
          </div>
          <div className="flex justify-center md:justify-start"></div>
          <div className="mb-24 flex justify-center md:justify-start">
            <NavLink className="w-full md:w-fit" to="sign-up">
              <ButtonComponent
                label="Open a New World"
                fullWidth
                size="large"
                type="primary"
                id="new-world-button"
                iconEnd={<ArrowDiagonalRight stroke="white" />}
              />
            </NavLink>
          </div>
        </div>
        <div className="order-1 flex items-center justify-center md:order-2">
          <LandingPageImage />
        </div>
      </div>

      <aside
        id="default-sidebar"
        className={`fixed top-0 left-0 z-40 h-screen w-64 transition-transform ${
          showSideBar ? "translate-x-0" : "-translate-x-full"
        }`}
        aria-label="Sidebar"
      >
        <div className="flex h-full flex-col justify-between overflow-y-auto border-2 border-gray-100 bg-white px-3 py-4">
          <ul className="space-y-5 font-medium">
            <li>
              <CloseOutlinedIcon onClick={() => onSetShowSideBar(false)} />
            </li>
            <li>
              <NavLink to={SIGN_IN}>
                <ButtonComponent
                  label="Sign In"
                  size="large"
                  type="tertiary"
                  id="new-world-button"
                  className="font-bold"
                />
              </NavLink>
            </li>
            <li>
              <NavLink className="w-full md:w-fit" to="sign-up">
                <ButtonComponent
                  label="Open a New World"
                  fullWidth
                  size="large"
                  type="primary"
                  id="new-world-button"
                  iconEnd={<ArrowDiagonalRight stroke="white" />}
                />
              </NavLink>
            </li>
          </ul>
          <div>
            <img alt="Banner" src={Banner} />
          </div>
        </div>
      </aside>
    </div>
  );
});

export default LandingPage;
